import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
	selector: 'tk-tag',
	templateUrl: './tag.component.html',
	styleUrls: ['./tag.component.sass'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TagComponent {}
